export default function CROServicesSection() {
    const services = [
        { title: "CRO Audits and Consultations", icon: "📊" },
        { title: "Landing Page Optimization", icon: "🖥️" },
        { title: "A/B and Multivariate Testing", icon: "⚖️" },
        { title: "Checkout and Form Optimization", icon: "🛒" },
        { title: "eCommerce Conversion Optimization", icon: "💰" },
        { title: "Heatmap and Behavior Tracking", icon: "🔥" },
        { title: "Mobile CRO and Performance Enhancement", icon: "📱" },
        { title: "UX and Design Improvements", icon: "🎨" },
        { title: "Analytics Setup and Data Reporting", icon: "📈" },
    ];

    return (
        <div className="SectionCRO py-[20px] md:py-[50px] bg-gray-100">
            {/* Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our <span className="text-[#DA2128]">CRO Services</span> for UAE Businesses
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    At Mean3, we offer a full range of CRO services tailored to your business goals:
                </p>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300 p-6 rounded-2xl shadow-md bg-[#f5f5f5]"
                    >
                        {/* Icon */}
                        <div className="text-4xl md:text-5xl mb-4">{service.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {service.title}
                        </h3>
                    </div>
                ))}
            </div>

            {/* Closing Note */}
            <div className="text-center mt-12 max-w-2xl mx-auto">
                <p className="text-[#555] !text-[16px] md:!text-[18px] font-bold">
                    Whether you run an ecommerce store, a service website, or a B2B portal, our team ensures your site delivers results.
                </p>
            </div>
        </div>
    );
}
